import {createApp} from 'vue'
import OnlineDonationQRPrintPageContent from './OnlineDonationQRPrintPageContent'
import handleComponentProps from 'foundation/js/utils/handleComponentProps'

const el = '.kb-component--online-donation-qr-print-page-content'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((OnlineDonationQRPrintPageContentDOM)=>{
            const props = handleComponentProps(OnlineDonationQRPrintPageContent, OnlineDonationQRPrintPageContentDOM)
            const component = createApp(OnlineDonationQRPrintPageContent, props).use(Store)
            component.mount(OnlineDonationQRPrintPageContentDOM)
        })
    }
}